export class MemberEmail {
	constructor(data) {
		this.id = data && data.id ? data.id : undefined;
		this.email = data && data.email ? data.email : undefined;
	}
}
